"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var app_1 = __importDefault(require("../../crud-simple/generic/app"));
var DataInterfaceUtils = __importStar(require("./data-interface"));
var DataDefinitionUtils = __importStar(require("./data-definition"));
var U = __importStar(require("../utils"));
var EntityCrudApp = function (_a) {
    var entities = _a.entities, apiUrl = _a.apiUrl, mockData = _a.mockData, _b = _a.urlPrefix, urlPrefix = _b === void 0 ? '' : _b, withBackend = _a.withBackend;
    var entityName = react_router_dom_1.useParams().entityName;
    var entity = U.getEntityByName(entityName, entities);
    var dataInterface = DataInterfaceUtils.generate(entity, apiUrl, withBackend, mockData);
    var dataDef = DataDefinitionUtils.generate(entity, entities, urlPrefix, apiUrl, withBackend, mockData);
    return react_1["default"].createElement(app_1["default"], { dataDef: dataDef, Data: dataInterface });
};
exports["default"] = EntityCrudApp;
